export function localStorageKeyForRoomNotes(roomId) {
    return `notes-${roomId}`;
}
//# sourceMappingURL=local_storage_key_for_room_notes.js.map